import { MagnifyingGlassIcon, UserGroupIcon, } from '@heroicons/react/24/solid'
import { GiFamilyTree } from "react-icons/gi";
import { FaPeopleRoof } from "react-icons/fa6";
import { GiPhotoCamera } from "react-icons/gi";
import { NavLink } from 'react-router';
import GridType from '../../models/GridType.ts';
import { setRbr as setPersonRbr } from '../../reducers/personDetailsReducer.js';
import { setRbr as setFamilyRbr } from '../../reducers/familyDetailsReducer.js';


import { useDispatch } from 'react-redux';


function Row({ title, text, onClickHandler, photo, id, isOnPhoto, hasHouseHold, hasOptions, optionsType  }) {

  const dispatch = useDispatch();

  const  detailsClick = function() {

    if (optionsType === "К"){
      dispatch(setFamilyRbr(id)); 
    }else{
      dispatch(setPersonRbr(id)); 
    }

  }

  return (
    <div onClick={onClickHandler} className="flex max-md:flex-col items-stretch border border-gray-700 bg-white  w-full">
      <div onClick={onClickHandler} className="flex font-light md:flex-row flex-grow items-start md:items-center gap-1 sm:gap-3 flex-col p-2 sm:p-3 ">
        <div className='flex md:flex-r gap-3 self-stretch items-center flex-grow'>

          <h5 className='text-sm sm:text-md'>
            {title}
          </h5>
          <div className='flex-grow'>
          </div>

        </div>
        {/* <hr className='border md:border-0 self-stretch border-slate-600'></hr> */}

        <p className='text-xs sm:text-sm'>
          {text}
        </p>

      </div>
      <div className='flex bg-gray-200 p-2 sm:p-3 gap-4 sm:gap-6 items-center'>
        {hasOptions &&
        <MagnifyingGlassIcon onClick={detailsClick} className='transition-all md:hover:scale-110 size-5 md:size-8 cursor-pointer'></MagnifyingGlassIcon>
        }
        {

          hasHouseHold ?
            <NavLink to={"/House/" + id} end>

              <FaPeopleRoof className='transition-all md:hover:scale-110 size-5 md:size-8'></FaPeopleRoof>
            </NavLink>
            :
            <FaPeopleRoof className='text-slate-400 size-5 md:size-8'></FaPeopleRoof>
        }


        {
          photo ?

            <NavLink to={"/Document/" + photo} end>
              <GiFamilyTree className='transition-all md:hover:scale-110 size-5 md:size-8'></GiFamilyTree>
            </NavLink>
            :

            <GiFamilyTree className='text-slate-400 size-5 md:size-8'></GiFamilyTree>
        }
        {
          isOnPhoto ?
            <NavLink to={"/Grid/" + GridType.Person + "/" + id} end>

              <GiPhotoCamera className='transition-all md:hover:scale-110 size-5 md:size-8' />
            </NavLink>

            :

            <GiPhotoCamera className='text-slate-400 size-5 md:size-8' />

        }


      </div>
    </div>
  );
}

export default Row;
